import { Link } from "react-router-dom";
import Seo from "../lib/Seo";
import { Arrow } from "../components/Icons";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Dialed In" description="That page has wandered off the fairway." />
      <section className="page-head" style={{ minHeight: "60vh" }} data-testid="not-found-page">
        <div className="wrap">
          <div className="label">404</div>
          <h1 className="disp page-h">That one's <span className="g">out of bounds.</span></h1>
          <p className="page-sub">The page you're looking for doesn't exist. Take a drop and play on.</p>
          <div style={{ marginTop: "5vh" }}>
            <Link className="cta" to="/" data-testid="notfound-home-cta">Back to the clubhouse <Arrow /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
